import { createRoute, useRouter } from "@tanstack/react-router"

import { PersonProfileContent } from "@/components/community/person-profile-content"
import MainAppRoute from "@/rootRoutes/MainApp"

const PersonDetailsRoute = createRoute({
  getParentRoute: () => MainAppRoute,
  path: "/persons/$personId",
  component: PersonDetails,
})

export default PersonDetailsRoute

function PersonDetails() {
  const { personId } = PersonDetailsRoute.useParams()
  const router = useRouter()

  return (
    <PersonProfileContent
      personId={personId}
      onBack={() => router.history.back()}
    />
  )
}
